/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../../../_chunks/dep-b011b919.mjs';
import setStyle from '../utils/set-style.mjs';
import { getIEVersion } from '../utils/helper.mjs';
import '../../../_chunks/dep-ae1abe1d.mjs';
import '../../../_chunks/dep-56ceb7ce.mjs';
import '../../../_chunks/dep-2a2a0e63.mjs';
import '../../../_chunks/dep-c3626417.mjs';
import '../../../_chunks/dep-fc63c737.mjs';
import '../../../_chunks/dep-7f2f03b4.mjs';
import '../../../_chunks/dep-eba62589.mjs';
import '../../../_chunks/dep-7d9e11c8.mjs';
import '../../../_chunks/dep-b9567f6a.mjs';
import '../../../_chunks/dep-654b4b01.mjs';
import '../../../_chunks/dep-a6022780.mjs';
import '../../../_chunks/dep-e00db566.mjs';
import '../../../_chunks/dep-fdde96c5.mjs';
import '../../../_chunks/dep-961339ce.mjs';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function circleAdapter(circleElem) {
  var _window, _window$getComputedSt2, _window2, _window2$navigator;
  var basicStyle = {};
  if (!circleElem || typeof window === "undefined") {
    return;
  }
  var _window$getComputedSt = (_window = window) === null || _window === void 0 ? void 0 : (_window$getComputedSt2 = _window.getComputedStyle) === null || _window$getComputedSt2 === void 0 ? void 0 : _window$getComputedSt2.call(_window, circleElem),
    color = _window$getComputedSt.color,
    fontSize = _window$getComputedSt.fontSize;
  var ua = (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$navigator = _window2.navigator) === null || _window2$navigator === void 0 ? void 0 : _window2$navigator.userAgent;
  var isSafari = /Safari/.test(ua) && !/Chrome/.test(ua);
  var isIosWechat = /(?=.*iPhone)[?=.*MicroMessenger]/.test(ua) && !/Chrome/.test(ua);
  if (isSafari || isIosWechat) {
    basicStyle = {
      transformOrigin: "0px 0px",
      transform: "scale(".concat(parseInt(fontSize, 10) / 12, ")")
    };
  }
  if (color && getIEVersion() > 11) {
    var matched = color.match(/[\d.]+/g);
    var endColor = matched ? "rgba(".concat(matched[0], ", ").concat(matched[1], ", ").concat(matched[2], ", 0)") : "";
    setStyle(circleElem, _objectSpread(_objectSpread({}, basicStyle), {}, {
      background: "conic-gradient(from 90deg at 50% 50%,".concat(endColor, " 0deg, ").concat(color, " 360deg)")
    }));
  } else {
    setStyle(circleElem, _objectSpread(_objectSpread({}, basicStyle), {}, {
      background: ""
    }));
  }
}

export { circleAdapter as default };
//# sourceMappingURL=circle-adapter.mjs.map
